import React from 'react';
import { Button, Grid, InputAdornment, TextField, Typography, Input } from '@material-ui/core';
import { PlusIcon, SearchIcon, UploadIcon, FileDownloadIcon } from '../../icons';

export default function AdminHeader({
    title,
    search,
    onSearch,
    createLabel,
    onCreate,
    importLabel,
    onImport,
    onDownloadSample,
    downloadSampleLabel,
    children,
    childrenBefore = false
}) {
    return (
        <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
        >
            <Grid item>
                <Typography variant="h2">{title}</Typography>
            </Grid>
            <Grid item>
                <Grid container justifyContent="flex-end" alignItems="center" spacing={2}>
                    {childrenBefore && children}
                    {onSearch && (
                        <Grid item>
                            <TextField
                                autoFocus
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }}
                                variant="outlined"
                                placeholder="Search..."
                                value={search || ''}
                                size="small"
                                onChange={ev => {
                                    onSearch(ev.target.value);
                                }}
                            />
                        </Grid>
                    )}
                    {onCreate && (
                        <Grid item>
                            <Button
                                onClick={onCreate}
                                variant="contained"
                                color="primary"
                                startIcon={<PlusIcon />}
                            >
                                {createLabel}
                            </Button>
                        </Grid>
                    )}
                    {onImport && (
                        <Grid item>
                            <Input
                                id="upload-batch-file"
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                style={{ display: 'none' }}
                                onChange={onImport}
                            />
                            <label htmlFor="upload-batch-file">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<UploadIcon />}
                                >
                                    {importLabel}
                                </Button>
                            </label>
                        </Grid>
                    )}
                    {onDownloadSample && (
                        <Grid item>
                            <Button
                                onClick={onDownloadSample}
                                variant="contained"
                                color="primary"
                                startIcon={<FileDownloadIcon />}
                            >
                                {downloadSampleLabel}
                            </Button>
                        </Grid>
                    )}
                    {!childrenBefore && children}
                </Grid>
            </Grid>
        </Grid>
    );
}
